import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((_theme) => ({
  root: {
    backgroundColor: '#FFF',
    border: '2px solid #ffb15d',
    borderRadius: 10,
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop:15,
    overflow: 'hidden',
    position: 'relative',
    height: 'fit-content',
  },

  body: {
    flexGrow: 1,
    padding: 15,
    paddingTop: 5,
  },

}));

export default useStyles;
